const turkish: any = {
  message: {
    value: "Bu bir deneme metnidir..",
  },
  bookingTitle: {
    value: "Vekâlet Veriyorum",
  },
  countTilte1: {
    value: "Kurban (Vekâlet) Sahipleri",
  },
  countMsg1: {
    value:
      "Vekâlet vereceğiniz kurban türü ve vekâlet sahibi bilgilerini giriniz.",
  },
  countTilte2: {
    value: "İletişim Bilgileriniz",
  },
  countMsg2: {
    value: "Formu dolduran kişi olarak size ait bilgileri giriniz.",
  },
  countTilte3: {
    value: "Ödeme Bilgileri",
  },
  countMsg3: {
    value: "Kredi Kartı bilgilerinizi giriniz.",
  },
  submit: {
    value: "ONAYLA",
  },
  totalQurban: {
    value: "Toplam hisse",
  },
  totalPayment: {
    value: "Toplam tutar",
  },
  paymentType: {
    value: "Ödeme Şekli:",
  },
  termsCondition: {
    value:
      '<p> Kurban organizasyonu ile ilgili <span class="termsItem"> <span class="policyItem"> aydınlatma metni </span> </span> okudum ve kabul ediyorum </p>',
  },
  termsEyyup: {
    value:
      '<p>Organizasyon <span class="org-policy">şartlarını </span> kabul ettim, isimlerini yazdığım kişiler için kurban kesmeye ve kestirmeye <span class="termsItem with-hover"> <b> ilgili kişileri  </b><span class="hover-popup">Emrah Sönmez, Faik Koç, M. Osman Özaslan, Abdülkerim Gür, Kemal Yörükoğlu, Fırat Özakdağ, Mustafa Erer</span></span> vekil tayin ettim.</p>',
  },
  thirdPerson: {
    value:
      '<p>Üçüncü kişilere ait verileri paylaşmış olmam halinde onaylarını aldığımı <span class="termsItem with-hover"><b>beyan</b><span class="hover-popup">Kurban vekâletinin verilmesi ve/ya kurban etlerinin dağıtılması amaçlarıyla Vakfınızla paylaştığım üçüncü kişilere (vekâlet sahibi ve/ya hak sahibine) ait veriler için ilgili kişilerin onayını aldığımı, hukuka aykırı kişisel veri aktarımından kaynaklanabilecek her türlü hukuki sorumluluğu üstlendiğimi kabul ve beyan ederim.</span></span> ederim.</p>',
  },
  OrganitionPolicyContent: {
    value:
      "<div class='mec-terms'>   <h2>18. MEC Uluslararası Kurban Organizasyonu Şartları</h2>   <p>18. MEC Uluslararası Kurban Organizasyonu ('Organizasyon') Mahmud Esad Coşan Eğitim, Kültür, Dostluk ve Yardımlaşma Vakfı ('MEC Vakfı') tarafından düzenlenmektedir. MEC Vakfı’na, Bakanlar Kurulunun 13/01/2014 tarihli ve 2014/5824 sayılı kararıyla vergi muafiyeti tanınmış ve Cumhurbaşkanının 07/03/2023 tarihli ve 2023/6907 sayılı kararıyla izin almadan yardım toplayabilen vakıflardan olmasına kararı verilmiştir.</p>   <p>Organizasyon kapsamında Endonezya'da yapılacak dağıtıma esas teşkil eden kurbanlık hayvanların temini, kesimi, paketlenmesi, soğuk zincir korunarak Endonezya'ya lojistiği süreçlerinde MEC Foundation (Avustralya); Endonezya'da ihtiyaç sahiplerinin tespiti ve kurban etlerinin dağıtımı süreçlerinde ise Yayasan Server (Endonezya) kuruluşları ile iş birliği yapılmaktadır.</p>   <p> Organizasyon'a ilişkin hüküm ve şartlar aşağıdaki gibidir:</p>   <ul>     <li>Organizasyon'un; kurban ibadeti şartlarına, yürürlükteki mevzuata, genel temizlik kurallarına ve hayvan haklarına uygun yürütülmesi için azami düzeyde hassasiyet gösterilmektedir.</li>     <li>Kurbanlık hayvanların belirlenmesinde, İslâmi gerekliliklere ve hassasiyetlere dikkat edilmektedir.</li>     <li>Organizasyon için ülkemizde kesimi yapılacak büyükbaş hayvanların ağırlığı ortalama 350 kg, Avustralya'da kesimi yapılacak küçükbaş hayvanların ağırlığı ise ortalama 45-50 kg olarak belirlenmektedir. Ülkemizde büyükbaş hayvanların, Avustralya'da küçükbaş hayvanların belirli bir kotası bulunmaktadır.</li>     <li>Ülkemizde yapılan kesimlere Diyanet İşleri Başkanlığı görevlileri ile noterler; Avustralya'da yapılan kesimlere ise Helal Tescil Kuruluşu görevlileri eşlik etmektedir.</li>     <li>Ülkemizde dağıtımı tercih eden vekâlet sahipleri tarafından kurban etlerinin dağıtımına (belirlenen kota kapsamında) gönüllü olarak katılma imkânı bulunmaktadır. Böyle bir tercihi olan vekâlet sahipleri ile süreç içerisinde iletişim kurulmaktadır.</li>     <li>Kurban etlerinin dağıtılacağı ihtiyaç sahipleri hem ülkemizde hem de Endonezya'da; ilgili kamu kurum ve kuruluşlarının da yardımı ile dağıtım yapılacak şehirlerdeki gönüllüler tarafından tespit edilmektedir.</li>     <li>Organizasyon kapsamında kesimler Balıkesir’de; dağıtımlar ise Adana, Adıyaman, Ankara, Bursa, Gaziantep, Hatay, İstanbul, Kahramanmaraş, Kayseri, Kocaeli, Konya, Malatya, Osmaniye, Sakarya ve Şanlıurfa’da gerçekleştirilmektedir.</li>     <li>Kesimden sonra elde edilen sakatat ve deri gelirleri MEC Vakfı’na aktarılmaktadır.</li>     <li>Kişisel verilerinizin mevzuata uygun olarak işlenmesine, verilerinizin mahremiyeti ile güvenliğinin sağlanmasına dikkat edilmektedir. Organizasyon için hazırlanan aydınlatma metnine <span class='policyItem'>buradan</span> ulaşılabilmektedir.</li>   </ul> </div>",
  },
  termsMessage: {
    value:
      "<h4 style=\"font-size: 16px; text-align:center; font-weight: 600;\">Şartlar</h4><p>Kurban vekaleti ile ilgili olarak aşağıdaki şartları kabul ediyorum.</p> <p>Sitemizde gerçekleştirdiğiniz bağış işlemlerine ait bilgiler SSL protokolü ile şifrelenerek aktarılmaktadır. 128 bit SSL sayesinde işlem süreçlerinde iletilen veriler üçüncü şahıslar tarafından okunamaz ve değiştirilemez.</p><p>Bağış sırasında kullanılan kredi kartı ile ilgili bilgiler şifrelenerek bankaya gönderilmekte ve provizyon işlemi gerçekleştirilmektedir. Kartla ilgili hiçbir bilgi tarafımızdan kaydedilmediğinden, üçüncü şahısların herhangi bir koşulda bu bilgileri ele geçirmesi mümkün değildir.</p><p>Avustralya Mahmud Es'ad Coşan Vakfı, HİÇBİR ŞEKİLDE VE KOŞULDA kredi kartı bilgilerinizi kaydetmemektedir.</p><p>Kişisel bilgilerinizin güvenliği için işlemlerinizi şahsi bilgisayarınızda gerçekleştirmeye özen gösteriniz. İnternet kafe gibi halka açık yerlerde kesinlikle mali nitelikli işlem yapmayınız.</p><p>Tüm tahsilat işlemleri Avustralya Doları olarak yapılmaktadır. Bankanız kredi kartınıza tahsilat tutarını yerel kur çevrimi yaparak yansıtabilir. Bankaların uyguladığı kur politikaları ve uluslararası işlem ücreti gibi ücretlerin vakfımız ile ilgisi bulunmamaktadır.</p><p>Yaptığınız ödemelere taksit uygulanmamaktadır. Ancak bankanız işlemi kredi kartınıza taksitli olarak yansıtabilir. Bu durum bankanız ile ilgilidir.</p><p>Vekaleti alınmış tüm vacib kurbanlar, Avustralya'da Kurban Bayramı süresi içinde kesilecektir. Kurban Bayramı'nın tarihi Avustralya ile Türkiye arasında bir gün farkedebilmektedir. </p> <p>Vakfımız tarafından yapılan bu tahsilat kurbanlık bedeli, uluslararası nakliyat, gümrükleme bedeli, idari masraflar vb. harcamalar için kullanıldıktan sonra arta kalan tutar olması halinde, artan tutarın değerlendirilmesi vakfımızın tasarrufuna bırakılmış sayılır.</p>",
  },
  share: {
    value: "HİSSE",
  },
  qurbanWakalah: {
    value: "Kurban Vekâlet",
  },
  add: {
    value: "EKLE",
  },
  wname: {
    value: "Vekâlet Sahibi",
  },
  wMobile: {
    value: "CEP TELEFONU",
  },
  wemail: {
    value: "E-posta",
  },
  qurban: {
    value: "KURBAN",
  },
  qurbanTypeSelect: {
    value: "Kurban tipini seçiniz",
  },
  wakalah: {
    value: "VEKALET",
  },
  qurbanqty: {
    value: "MİKTAR",
  },
  qurbanlişstempty: {
    value:
      "Kurban Listesi boş. Üstteki boşluklara gerekli bilgileri girip EKLE butonuna tıklayarak kurban ekleyebilirsiniz.",
  },
  sheep: {
    value: "Küçükbaş - 3.750 TL - Endonezya (KOTA DOLDU)",
  },
  cattle: {
    value: "Büyükbaş - 5.900 TL - Türkiye",
  },
  wajib: {
    value: "Vacip",
  },
  aqiqah: {
    value: "Akika",
  },
  nadhr: {
    value: "Adak",
  },
  other: {
    value: "Sadaka",
  },
  fieldcannotbeEmpty: {
    value: "Bu Alanı Boş Bırakmayınız!",
  },
  wakalahtelError: {
    value:
      "Lütfen numaranızı ve (telefon bilgisi kutucuğunun sol tarafında bulunan bayrak ikonundan) ülke telefon kodunuzu kontrol ederek tekrar deneyiniz.",
  },
  wemailerror: {
    value: "Geçersiz e-posta adresi!",
  },
  fullname: {
    value: "Adı Soyadı ",
  },
  mobilephone: {
    value: "Cep Telefonu",
  },
  country: {
    value: "Ülke",
  },
  city: {
    value: "Şehir",
  },
  town: {
    value: "İlçe",
  },
  contactError: {
    value: "İletişim bilgilerini eksiksiz doldurmalısınız!",
  },
  policyError: {
    value:
      "Kayıt işlemini tamamlayabilmek için ilk iki kutucuğunu işaretlemelisiniz!",
  },
  prevtotal: {
    value: "Toplam Tutar",
  },
  prevContactTitle: {
    value: "Formu Dolduran Kişi",
  },
  prevWakalahTitle: {
    value: "Vekâlet Sahipleri",
  },
  prevTitle: {
    value: "Lütfen Vekâlet Bilgilerinizi Kontrol Edin.",
  },
  tableheadOwner: {
    value: "Vekalet Veren",
  },
  tableheadPhone: {
    value: "Cep Telefonu",
  },
  tableheadEmail: {
    value: "E-Posta",
  },
  tableheadQty: {
    value: "Sayı",
  },
  tableheadTypeNote: {
    value: "Kurban Türü",
  },
  back: {
    value: "GERİ",
  },
  payment: {
    value: "ÖDEME YAP",
  },
  waiting: {
    value: "Lütfen  Bekleyin...",
  },
  waitingMsg: {
    value: "Lütfen bekleyiniz, işleminiz birkaç saniye sürebilir.",
  },
  successTitle: {
    value: "Kurban vekaletiniz başarıyla alındı.",
  },
  sharePickup: {
    value: "Kurban Eti İkramı istiyorsanız tıklayın",
  },
  dear: {
    value: "Sayın",
  },
  paymentSuccess: {
    value: "Ödemeniz ve vekalet bilgileriniz başarıyla alındı.",
  },
  qurbanData: {
    value:
      "1444/2023 Uluslararası Kurban Organizasyonumuza gösterdiğiniz ilgiye teşekkür ederiz",
  },
  refrenceNo: {
    value: "Referans Numaranız",
  },
  totalPaid: {
    value: "Toplam Ödenen",
  },
  printBtn: {
    value: "YAZDIR",
  },
  home: {
    value: "Qurban Sayfası",
  },
  notifTitle: {
    value: "AÇIKLAMA",
  },
  notifDate: {
    value: "1444/2023 yılı",
  },
  notifMsg: {
    value: "Kurban vekalet kabulümüz sona ermiştir.",
  },
  notifThanks: {
    value: "İlginiz için Teşekkür ederiz.",
  },
  btnQuery: {
    value: "Vekâlet Sorgu",
  },
  wakalahQueryTitle: {
    value: "Vekâlet Sorgulama",
  },
  queryBtnText: {
    value: "SORGULA",
  },
  qureyDescText: {
    value:
      "Bilgilerine ulaşmak istediğiniz kurban formuna ait referans numarasını ve formu doldururken kullanmış olduğunuz e-mail adresinizi girin.",
  },

  queryFormFiller: {
    value: "Formu Dolduran Kişi",
  },
  querytotalQurabnShare: {
    value: "Toplam Kurban / Hisse Sayısı",
  },
  queryTotalpaid: {
    value: "Kurban İçin Toplam Tutar",
  },
  queryPaymentStatus: {
    value: "Ödeme Durumu",
  },
  querySlaugtherStatus: {
    value: "Kesim Durumu",
  },
  cardNumber: {
    value: "Kart Numarası",
  },
  expiryDate: {
    value: "Son Kullanma Tarihi",
  },
  cvc: {
    value: "CVC",
  },
  removeCard: {
    value: "Kaldır",
  },
  paymentControlText: {
    value:
      "Ödeme öncesi işlemlerinizi kontrol ederek yeniden düzenleyebilirsiniz.",
  },
  NameTransferText: {
    value:
      "Ad ve soyad bilgimin, Avustralya'da kesimi yapacak kişiye aktarılmasına izin veriyorum.",
  },
  kvkkContent: {
    value:
      '<div class="kvkk-content"> <h1>KURBAN ORGANİZASYONU AYDINLATMA METNİ</h1> <br/> <h1>I. Veri Sorumlusu</h1> <br/> <p>6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") uyarınca, kişisel verileriniz; veri sorumlusu olarak Mahmud Esad Coşan Eğitim, Kültür, Dostluk ve Yardımlaşma Vakfı ("<b>MEC Vakfı</b>" veya "<b>Vakıf</b>") tarafından aşağıda açıklanan kapsamda işlenmektedir.</p> <br/> <h1>II. Kişisel Verileri Toplama Yöntemleri ve Hukuki Sebepleri</h1> <br/> <p>Kişisel veri, kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü veriyi kapsamaktadır. Kişisel verinin özel bir türü olan özel nitelikli kişisel veri ise ırk, etnik köken, siyasi düşünce, felsefi inanç, din, mezhep, diğer inançlar, kılık ve kıyafet, dernek, vakıf veya sendika üyeliği, sağlık, cinsel hayat, ceza mahkumiyeti ve güvenlik tedbirleri, biyometrik ve genetik verileri ifade eder.</p> <p>Vakfımız kişisel verileri; vekâlet sahibinin kendisinden veya yakınlarından, gönüllülerin kendisinden, sivil toplum kuruluşlarından veya kamu kurum ve kuruluşlarından, elektronik ortamda vekâlet formu doldurulmak suretiyle, Kanun’da belirtilen kişisel veri işleme şartlarına uygun ve kurban ibadetinin yerine getirilmesi amacıyla doğru orantılı olarak, Kanun’un 5. maddesinde belirtilen aşağıdaki hukuki sebepler doğrultusunda toplamaktadır:</p> <ul>     <li>Kanunlarda kişisel verilerinizi işlediğimiz sürecin açıkça öngörülmesi (örneğin, ayni yardımların dağıtılması için mevzuat gereği kullanılması gereken formlara kimlik verilerinizin işlenmesi veya imza alınması)</li>     <li>Sizlerle bir sözleşme ilişkisi kurmamız veya bu sözleşmeden kaynaklanan ifa yükümlülüğümüz ile doğrudan doğruya ilgili olması kaydıyla, sizlere ait kişisel verilerin işlenmesinin gerekli olması (örneğin, vekâlet bedelinin temin edilmesi için kredi kartı bilgilerinin alınması)</li>     <li>Hukuki yükümlülüğümüzü yerine getirebilmek için zorunlu olan durumlar (örneğin, bilgi güvenliği yükümlülüklerine uyumu temin etmek ve gerektiği durumlarda Kanun’a uyumu sağlamak için işlem kayıtlarının izlenmesi ve incelenmesi)</li>     <li>Sizlere bir hak tesis etmemiz, bu hakkı kullandırmamız veya korumamız için veri işlemek zorunda oluşumuz (örneğin, vekâlet sözleşmesi kapsamında kurban ibadetinizin sizin adınıza Vakfımız görevlilerince yerine getirilmesi amacıyla kimlik verilerinizin işlenmesi)</li>     <li>Gerekli olduğu durumlarda sizlerden aldığımız açık rızanız (örneğin, kurbanınızın yurt dışında dağıtılmasını istemeniz halinde kişisel verilerinizin yurt dışına aktarılması)</li> </ul> <h1>III. Veri Kategorileri ve Veri Türleri</h1> <br/> <table cellspacing="0" border="1">   <tr>     <td rowspan="4">1.</td>     <td rowspan="4">Vekâlet sahibi</td>     <td>Kimlik Bilgisi</td>     <td>Ad ve soyad</td>   </tr>   <tr>     <td >İletişim Bilgisi</td>     <td>İl, ilçe, e-posta adresi, cep telefonu</td>   </tr>   <tr >     <td>Finansal Bilgi</td>     <td>Kredi kartı bilgileri</td>   </tr>   <tr>     <td>Özel Nitelikli Kişisel Veri</td>     <td>Kurban vekâlet bilgileri</td>   </tr>   <tr>     <td rowspan="3">2.</td>     <td rowspan="3">Gönüllü</td>     <td>Kimlik Bilgisi</td>     <td>Ad ve soyad</td>   </tr>   <tr>     <td>İletişim Bilgisi</td>     <td>İl, ilçe, e-posta adresi, cep telefonu</td>   </tr>   <tr>     <td>Hukukî işlem</td>     <td>İmza</td>   </tr>   <tr>     <td rowspan="3">3.</td>     <td rowspan="3">Hak sahibi</td>     <td>Kimlik Bilgisi</td>     <td>Ad ve soyad, T.C. kimlik numarası</td>   </tr>   <tr>     <td>İletişim Bilgisi</td>     <td>Adres</td>   </tr>   <tr>     <td>Hukukî işlem</td>     <td>İmza</td>   </tr> </table> <br/> <h1>IV. Kişisel Verilerin Hangi Amaçla İşleneceği</h1> <br/> <p>Yukarıda belirtilen kişisel veriler, bu verileri Vakfımıza açıklamanıza konu olan; kurban vekâletinin alınması, vekâlet gereğinin yerine getirilmesi, elde edilen etlerin dağıtılması, gerekli iletişimin sağlanması, Vakfımızın ve üyesi olduğu Server Platformu’nun diğer organizasyon ve faaliyetleri hakkında bilgilendirme yapılması, gerekli hukuki ve resmi süreçlerin yerine getirilmesi amaçlarıyla işlenecektir.</p> <br/> <h1>V. İşlenen Kişisel Verilerin Aktarılması</h1> <br/> <p>Vakfımız, kişisel verilerinizi "bilme gereği" ve "kullanma gereği" ilkelerine uygun olarak, gerekli veri minimizasyonunu sağlayarak, gerekli teknik ve idari güvenlik tedbirlerini alarak işlemeye özen göstermektedir. Kurban ibadetinizin vekâleten yerine getirilmesi ve elde edilen kurban etlerinin dağıtımı süreçlerinin veri akışını zaruri kılması nedeniyle işlediğimiz kişisel verileri yalnızca bu amaçla sınırlı olarak üçüncü kişilere aktarmak durumundayız. Dolayısı ile kişisel verileriniz, söz konusu amacın gerçekleştirilmesi doğrultusunda ve bu amaçların yerine getirilmesi ile sınırlı olarak; kesimi gerçekleştirecek firma personeli ve et dağıtımını yapacak gönüllülerimiz ile paylaşılmaktadır. Bu sürecin doğru bir şekilde yerine getirilebilmesi için kişisel verilerinizin doğru ve güncel olması çok önemlidir.</p> <br/> <p>Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda ve bu amaçların yerine getirilmesi ile sınırlı olarak; Vakfımızca alınan vekâlet gereğinin yerine getirileceği tesislerdeki firma personeline, hak sahiplerine yapılacak dağıtımla sınırlı olmak üzere Vakıf gönüllülerine, bilişim altyapımızı sağlayan, işleten veya hizmet sunan iş ortaklarımıza ve hizmet sağlayıcılarımıza, kanunen yetkili kamu kurumları ve özel kişi veya kuruluşlar ile üçüncü kişilere, hukuki yükümlülüklerin yerine getirilmesi kapsamında avukatlar ve denetçilere, düzenleyici ve denetleyici kurumlar ile mahkeme ve icra müdürlükleri gibi sair resmi kurumlara, kişisel verilerinizi talep etmeye yetkili olan diğer kamu kurum veya kuruluşlarına işbu aydınlatma metninde belirtilen amaçlarla sınırlı olarak aktarılabilecek, yurt içinde veya yurt dışında işlenebilecektir.</p> <br/> <h1>VI. İlgili Kişinin Hakları</h1> <p>Kişisel verisi işlenen kişi olarak, Kanunun ilgili kişinin haklarını düzenleyen 11. maddesi kapsamındaki taleplerinizi (kişisel veri işlemeyi öğrenme, işlemeyle ilgili bilgi talep etme, işlemenin amaca uygunluğunu öğrenme, aktarım yapılan kişileri bilme, eksik veya yanlış işlemelerin düzeltilmesini isteme, silme veya yok edilmesini isteme, otomatik tüm işlemlerin üçüncü kişilere bildirilmesini isteme, analize itiraz etme, zararın giderilmesini talep etme) Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğe göre kullanmak için <a href="mailto:mec&#64;mec.org.tr">mec&#64;mec.org.tr</a> ile iletişime geçebilir veya <a href="https://mec.org.tr/kvkk-basvuru-formu" target="_blank">https://mec.org.tr/kvkk-basvuru-formu</a>adresinde yer alan formu kullanabilirsiniz.</p> </div>'
  },
  // contactPermitText:{
  //     value: 'MEC Vakfı\'nın diğer faaliyet ve projelerinden haberdar olmak için verilerin <sapn class="contact-policy"> işlenmesine izin </span> veriyorum.'
  // },
  contactPermitText: {
    value:
      'MEC Vakfı ile Server Platformu’nun faaliyetlerinden haberdar olmak istediğimi <span class="termsItem with-hover"><b>beyan</b><span class="hover-popup">MEC Vakfı’nın ve/ya Server Platformu’nun diğer faaliyet ve organizasyonları hakkında her türlü kanaldan benimle iletişime geçilmesini kabul ettiğimi, bunun için açık rızamın bulunduğunu beyan ederim.</span></span> ederim.',
  },
  contactPermitContent: {
    value:
      "<div class=\"contact-permit\"> <h1>İletişim İzni</h1> <p>MEC Vakfı'nın diğer faaliyet ve projelerinden haberdar olmak için verilerin işlenmesine izin veriyorum</p> <p> bu ve diğer organizasyonlarda iş birliği yapılan Server Yaşam Vakfı ile Hakyol Vakfı'nın proje ve faaliyetlerinden haberdar olmak için verilerin aktarılmasına izin veriyorum </p> <p>Eğer gelecek yıllarda ülkemizde düzenlenecek kurban organizasyonunun farklı bir kurum tarafından yürütülmesi ihtimali varsa, MEC Uluslararası Kurban Organizasyonu'nun duyuru ve kampanyaları hakkında bilgilendirme yapmak için izin veriyorum</p>  </div>",
  },
  distributionCountry: {
    value: "Dağıtım Ülkesi",
  },
  distributionCity: {
    value: "Dağıtım Yeri",
  },
  distributechecktext: {
    value: "Dağıtımda yer almak istiyorum",
  },
  distErrorMsg: {
    value: "Lütfen dağıtım ülkesi seçmeniz gerekiyor",
  },
  distribuCityErrorTxt: {
    value: "Lütfen dağıtım yeri seçmeniz gerekiyor.",
  },
  // distMsg:{
  //     value:"Ülke seçeneğinden; Avustralya’da kesilip Endonezya’da dağıtımı için <b>Avustralya</b>, Türkiye’de kesilip Türkiye'de dağıtılması için <b>Türkiye</b> seçeneğini işaretleyiniz."
  // },
  distMsg: {
    value:
      "Türkiye'deki dağıtımda yer almak isteyen hisse sahipleri ile iletişime geçilecektir.",
  },
  cardholderName: {
    value: "Kart Sahibinin Adı",
  },
  failureTitle: {
    value: "Ödeme işlemi başarsız oldu",
  },
  emptyCardInfoErrorTxt: {
    value: "Lütfen kart bilgileriniz giriniz.",
  },
  wakalahForm: {
    value: "VEKALET FORMU",
  },
  payment3DError: {
    value:
      '<h2>Üzgünüz!</h2> <div class="threederror-content"><p>Beklenmeyen bir durum oluştu. Tekrar deneyiniz.</p> <p>Sorun devam ederse bankanızla iletişime geçebilirsiniz.</p> </div> <span class="error-msg2">Hata:"{0}"</span>',
  },
  notfoundMsg: {
    value: "Üzgünüz, aradığınız sayfa mevcut değil veya kaldırılmış",
  },
  installmentPrice: {
    value: "Taksıtlı Tutar",
  },
  nameTransferError: {
    value: "Yurt dışı vekâletiniz için işaretlemelisiniz.",
  },
  disclaimerTxt: {
    value:
      '<span class="disclaimer">Bu form ile elde edilecek kişisel verileriniz, kurban süreçlerinin yerine getirilmesi amacıyla işlenecektir. Detaylı bilgi almak için <span class="policyItem"> aydınlatma metnini </span> inceleyebilirsiniz.</span>',
  },
  indonesiaTxt: {
    value: "ENDONEZYA",
  },
  turkeyTxt: {
    value: "TÜRKİYE",
  },
  contactInfoTransferMsg: {
    value: "Doldurduğum bilgileri aşağıdaki alana kopyala",
  },
  needySaved: `
    <div class='title33'>İhtiyaç Sahibi Bilgileri</div>
    <b>Ad Soyad :</b> {0}<br/>
    <b>Cep Telefonu :</b> {1}<br/>
    <b>Adres :</b> {2}<br/>
    {3} / {4}<br/>`,
  sharePickupResult: "Kurban eti ikramınızı bayramın 2. Günü (29 Haziran) saat 12.00 ile 18.00 arasında <span style='color: #6DB5E3'>{0}</span> teslim noktasından alabilirsiniz.",
  takePartZone: {
    value: 'KURBAN ETİ İKRAMI TESLİM NOKTASI'
  },
  Turkey: "Türkiye"
};

export default turkish;
